const actionVideo = () => {
    $('.carousel-item').each(function () {
        if (! $(this).hasClass('active')) {
            if ($(this).find('video').length) {
                $(this).find('video').get(0).pause();
            }
        } else {
            if ($(this).find('video').length) {
                let promise = $(this).find('video').get(0).play();
                if (promise !== undefined) {
                    promise.then(() => {
                        $(this).find('.button-play').addClass('d-none');
                        $(this).find('.button-pause').removeClass('d-none');
                    }).catch(() => {
                        $(this).find('.button-play').removeClass('d-none');
                        $(this).find('.button-pause').addClass('d-none');
                    });
                }
            }
        }
    });
};

actionVideo();

$('.carousel.slide').bind('slid.bs.carousel', actionVideo);

$('.button-play').click(function () {
    const $slide = $(this).parent();
    $slide.find('video').get(0).play();

    $(this).addClass('d-none');
    $slide.find('.button-pause').removeClass('d-none');
});

$('.button-pause').click(function () {
    const $slide = $(this).parent();
    $slide.find('video').get(0).pause();

    $(this).addClass('d-none');
    $slide.find('.button-play').removeClass('d-none');
});
